import { useCallback } from 'react';

import { CrossOriginCommunication } from '../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { OutgoingMessage } from '../controllers/crossOriginCommunication/types';
import { useConfigSlice } from '../store/slices/config/selectors';

/**
 * A hook that returns a callback function that will be called when the user exits from the game and send the game quite or close container events based on conditions.
 *
 * Return value can be undefined - this means that button closing it should not be displayed.
 * */
export const useExitCallbackConnected = (): (() => void) => {
  const casinoConfig = useConfigSlice.casinoConfig();
  const tableConfig = useConfigSlice.tableConfig();

  return useCallback(() => {
    if (casinoConfig?.notifyCloseContainer) {
      CrossOriginCommunication.dispatch(OutgoingMessage.CloseContainer, {
        tableId: tableConfig?.operatorGameId,
      });
    }

    if (casinoConfig?.returnMainPage) {
      CrossOriginCommunication.dispatch(OutgoingMessage.GameQuit, {
        tableId: tableConfig?.operatorGameId,
      });
    }
  }, [casinoConfig, tableConfig]);
};
